$(window).on('load', function() {
  "use strict";
  $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');
  $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');
  $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

  $('.submenu-li').parent('ul').addClass('sub-menu');
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.bannermenu-li').parent('ul').addClass('banner-menu');

  $('.slow-window').fadeOut('slow');

  var popup = localStorage.getItem('popup_value'); 
  if(popup != 1){
    $('#news-letter-modal').modal('show');
  }

  $('#popup-close').on('click',function(){
      localStorage.setItem('popup_value', '1');
  });
  // a11y: remember which control opened the menu or cart so focus can go back to it
  var panelTrigger = null;
  var panelToggles = "button.navbar-toggle, .shopping-cart a.cart-count";
  function focusFirstIn(panel) {
    window.setTimeout(function() {
      $(panel).find('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible').first().trigger('focus');
    }, 50);
  }
  function panelClosed() {
    $(panelToggles).attr("aria-expanded", "false");
    if (panelTrigger) {
      $(panelTrigger).trigger('focus');
      panelTrigger = null;
    }
  }

  $("button.navbar-toggle").on('click', function() {
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
    panelTrigger = this;
    $("button.navbar-toggle").attr("aria-expanded", "true");
    focusFirstIn(".main-menu-area");
  });

  $(".close-box").on('click', function() {
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
    panelClosed();
  });

  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
    panelTrigger = this;
    $(".shopping-cart a.cart-count").attr("aria-expanded", "true");
    focusFirstIn(".mini-cart");
  });

  // close control is a <button> now, so bind the button (not the inner icon) for keyboard clicks
  $(".shopping-cart-close").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
    panelClosed();
  });

  // Escape closes an open menu or cart and returns focus to its trigger
  $(document).on('keydown', function(e) {
    if (e.key !== "Escape" && e.key !== "Esc") { return; }
    if ($(".main-menu-area").hasClass("active") || $(".mini-cart").hasClass("show")) {
      $(".mini-cart").removeClass("show");
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
      panelClosed();
    }
  });

  // links that act as buttons (role="button") also activate with Space
  $(document).on('keydown', 'a[role="button"]', function(e) {
    if (e.key === " " || e.key === "Spacebar") {
      e.preventDefault();
      this.click();
    }
  });

   $(".ajax-spin-cart").on('click', function() {
    var trigger = this;
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
      panelTrigger = trigger;
      $(".shopping-cart a.cart-count").attr("aria-expanded", "true");
      focusFirstIn(".mini-cart");
    }, 1000);
  });

  // Tab and Shift+Tab stay inside the open cart or menu panel
  $(document).on('keydown', function(e) {
    if (e.key !== "Tab") { return; }
    var panel = $(".mini-cart").hasClass("show") ? $("#MiniCart") : ($(".main-menu-area").hasClass("active") ? $("#MobileMenu") : null);
    if (!panel || !panel.length) { return; }
    var items = panel.find('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
    if (!items.length) { return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !panel[0].contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !panel[0].contains(document.activeElement))) {
      e.preventDefault();
      first.focus();
    }
  });

  // filter button js
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });

  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  $(".mm-fullscreen-bg").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $(".filter-sidebar").removeClass("active");
    $("body").removeClass("hidden");
    panelClosed();
  });

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });

  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

      
  $('#top').on('click', function() {
    $("html, body").animate({ scrollTop: 0 }, 0);
    return false;
    });
  });

$(window).scroll(function(){
  if ($(this).scrollTop() > 1000) {
    $('#top').fadeIn();
  } else {
    $('#top').fadeOut();
  }

  var sticky = $('.header-bottom-wrap'),
  scroll = $(window).scrollTop();
  if (scroll >= 150) {
    sticky.addClass('is-sticky');
  }
  else {
    sticky.removeClass('is-sticky');
  }

  $('label.box-area').on('click', function () {
    if($('.cust-checkbox').is(':checked')) {
      $('.agree').removeClass('disabled');
    }
    else {
      $('.agree').addClass('disabled');
    }
  });
  
});